import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';
import { LivestreamSession } from './LivestreamSession';
import { EVENTS_I_AM_ADMIN_OF } from './SecurityRules';

export interface LivestreamSessionViewerRow {
  id: number;
  user_id: string;
  livestream_session_id: string;
}

export const LivestreamSessionViewer: Entity<LivestreamSessionViewerRow> = {
  id: 'LivestreamSessionViewer',
  title: 'Livestream Session Viewer',
  service: 'main',
  rowLabel: (row: LivestreamSessionViewerRow) => `${row.user_id} / ${row.livestream_session_id}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.livestream_session_viewer',
  },
  security: [
    {
      role: 'user',
      action: 'create',
      access: 'conditional',
      condition: `user_id = '{userId}'`,
    },
    {
      role: 'admin',
      action: 'create',
      access: 'conditional',
      condition: `user_id = '{userId}'`,
    },
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `user_id = '{userId}'`,
    },
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition:
        `user_id = '{userId}' OR livestream_session_id IN (` +
        `SELECT id FROM public.livestream_session WHERE event_id IN ${EVENTS_I_AM_ADMIN_OF}` +
        `)`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['id', 'DESC']],
  defaultFilters: [{ fieldId: 'livestream_session_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      mandatory: true,
      listColumn: true,
      refEntity: UserView,
    },
    livestream_session_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Livestream Session',
      mandatory: true,
      listColumn: true,
      refEntity: LivestreamSession,
    },
  },
};
